import { Button } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import type React from 'react';
import type { Boundaries, TimeWindow } from '../types';
import TimeInputs from './TimeInputs';

interface TimeWindowHeaderProps {
  timeWindow: TimeWindow;
  boundaries: Boundaries;
  isFilterApplied: boolean;
  onTimeInputChange: (value: string, field: 'startTime' | 'endTime') => void;
  onTimeBlur: (event: React.FocusEvent<HTMLInputElement>, field: 'startTime' | 'endTime', minValue: string, maxValue: string) => void;
  onClearFilter: () => void;
}

const TimeWindowHeader: React.FC<TimeWindowHeaderProps> = ({ timeWindow, boundaries, isFilterApplied, onTimeInputChange, onTimeBlur, onClearFilter }) => {
  return (
    <div className='flex items-center justify-between px-4 py-2'>
      <TimeInputs startTime={timeWindow.startTime} endTime={timeWindow.endTime} boundaries={boundaries} onTimeInputChange={onTimeInputChange} onTimeBlur={onTimeBlur} />
      <Button variant='outlined' size='sm' color='default' startIcon={<Icon name='x' />} disabled={!isFilterApplied} onClick={onClearFilter}>
        Limpar
      </Button>
    </div>
  );
};

export default TimeWindowHeader;
